import { render, staticRenderFns } from "./historyRecord.vue?vue&type=template&id=484a56c4&"
import script from "./historyRecord.vue?vue&type=script&lang=js&"
export * from "./historyRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports